export const GET_VEHICLES_TO_RELEASE = 'GET_VEHICLES_TO_RELEASE';
export const GET_VEHICLES_TO_RELEASE_SUCCESS = 'GET_VEHICLES_TO_RELEASE_SUCCESS';
export const GET_VEHICLES_TO_RELEASE_ERROR = 'GET_VEHICLES_TO_RELEASE_ERROR';

export const POST_VEHICLES_RELEASE_DATE = 'POST_VEHICLES_RELEASE_DATE';
export const POST_VEHICLES_RELEASE_DATE_SUCCESS = 'POST_VEHICLES_RELEASE_DATE_SUCCESS';
export const POST_VEHICLES_RELEASE_DATE_ERROR = 'POST_VEHICLES_RELEASE_DATE_ERROR';